<template>
  <div id="complaints">
    <!--显示类目选择，与填写互斥-->
    <div class="report-type report-type-box" v-show="!showReportEnter">
      <div class="funtion-title border-distance">请选择投诉该网页的原因</div>
      <div class="report-list">
        <div class="report-item report-content-type"
             v-for="(report,index) in reportList"
             :data-name="report.name"
             v-on:click="chooseType($event)"
        >{{report.name}}</div>
      </div>
      <a href="https://mp.weixin.qq.com/s/TbX1CcZhQNReneXVc3At9Q" class="report-law">遇到网页流量被劫持怎么办</a>
    </div>
    <a href="https://weixin110.qq.com/security/readtemplate?t=w_security_center_website/report_agreement" class="report-zhidao">投诉须知</a>
    <!--显示填写原因，与类目选择互斥-->
    <div class="report-type report-detail-box" v-show="showReportEnter">
      <div class="funtion-title border-distance">投诉描述</div>
      <div class="report-list">
        <div class="report-item report-type-show">{{chooseName}}</div>
<!--        <div class="report-content none">-->
<!--          <textarea name="" placeholder="请输入投诉相册名称" class="report-textarea" cols="30" rows="10"></textarea>-->
<!--        </div>-->
        <div class="report-item">
          <input type="text" placeholder="请输入您的联系方式" class="report-input" v-model="userContact">
        </div>
      </div>
      <div class="submit-button" v-on:click="submitReport($event)">投诉</div>
<!--      <span class="inputerror none">请输入要投诉的相册名称</span>-->
    </div>
    <div class="alert-shade" v-show="reportSuccess">
      <div>投诉成功，我们会尽快审核您提交的信息</div>
    </div>
  </div>
</template>
<style scoped>
  *{
    box-sizing: border-box;
  }

  #complaints{
    height:100%;
    background-color: rgb(241,240,244);
  }
  .border-distance{
    padding:0px 15px;
  }
  .report-type{

  }
  .report-type .report-list{
    background-color: #fff;
    border-top:1px solid #e5e5e5;
    border-bottom:1px solid #e5e5e5;
    padding-left: 15px;
  }
  .report-type .report-list .report-item{
    border-bottom: 1px solid #e5e5e5;
    font-size: 17px;
    color:#000;
    display: flex;
    align-items: center;
    height:44px;
  }
  .report-type .report-list .report-item:last-child{
    border-bottom: 0px;
  }
  .report-type .report-list .report-content{
    background-color: #e5e5e5;
    height:120px;
    border-bottom: 1px solid #e5e5e5;
  }
  .report-type .report-textarea{
    border: 0px;outline:none;cursor: pointer;
    border-radius: 0px;
    height:100%;
    width:100%;
    padding:10px 15px 10px 0px;
    font-size: 18px;
  }

  .funtion-title{
    font-size: 14px;
    line-height: 18px;
    color: #999;

    padding-top:12px;
    padding-bottom:8px;

    border: 0px;
  }
  .submit-button{
    margin:25px 15px 15px 15px;
    /*width:100%;*/
    background-color: rgb(81,169,56);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    height:46px;
    border-radius: 6px;
  }
  .inputerror{
    font-size: 14px;
    margin: 10px 15px;
    color: #db4415;
  }
  .report-law{
    font-size: 14px;
    margin: 6px 15px;
    color: #5A6E95;
    display: block;
  }
  .report-zhidao{
    position: fixed;
    bottom:16px;
    width:100%;
    text-align: center;
    font-size: 14px;
    color: #5A6E95;
  }

  .alert-shade{
    position: fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding:0 15px;
  }
  .alert-shade div{
    background: rgba(0,0,0,0.8);
    padding:10px 0;
    border-radius: 5px;
    text-align: center;
    font-size:15px;
    width:100%;
    color:#fff;
  }
  /*输入*/
  .report-type .report-input {
    height: 100%;
    width: 100%;
    line-height: 100%;
    padding: auto 15px auto 0px;
    border: 0px;
    outline: none;
    cursor: pointer;
  }
</style>

<script>
  export default {
    name: 'Complaints',
    data (){
      return {
        reportList:[
          {name:"网页包含欺诈信息（如：假红包）",},
          {name:"网页包含色情信息",},
          {name:"网页包含暴力恐怖信息",},
          {name:"网页包含政治敏感信息",},
          {name:"网页在收集个人隐私信息",},
          {name:"网页包含诱导分享/关注性质的内容",},
          {name:"网页可能包含谣言信息",},
          {name:"网页包含赌博信息",},
        ],

        //填写输入
        showReportEnter:false,
        //选择的类目名称
        chooseName:"",
        ///输入的联系方式
        userContact:"",

        //投诉成功
        reportSuccess:false,
      }
    },
    mounted() {
    },
    methods:{
      chooseType(event){///选择的类型
        var name = event.currentTarget.dataset.name
        console.log("选择了:"+name)
        ///填充
        this.chooseName = name;
        //填充可见
        this.showReportEnter = true
      },
      submitReport(event){//提交联系
        // console.log("chooseName:"+this.chooseName+",userContact:"+this.userContact)
        if(!this.userContact){
          alert("请输入联系方式")
        }
        //投诉成功
        var that = this
        this.$netGo.upComplaints(this.chooseName,this.userContact,this.shareId,function (res) {
          console.log("提交投诉成功")
          that.reportSuccess = true
          ///返回
          setTimeout(function () {
            that.$router.go(-1)
          },2000)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Complaints.vue